import { Paper } from '@mui/material';
import { styled } from '@mui/material';

export const AccountBox = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  ...theme.typography.body2,
}));
